import type { PublicApiKey } from '@/apilib';
import type { createMainMenuApi } from './mainMenuApi';

export const MainMenuApiKey: PublicApiKey<typeof createMainMenuApi> = {
  name: 'MainMenuApi',
  public: true,
};
